import { Modal, ModalOverlay, ModalCloseButton, ModalBody, useBreakpointValue } from '@chakra-ui/react';
import AdminModalContent from '../layout/AdminModalContent';
// import ClientEditModal from './ClientEditModal';
import ClientDetailModal from './ClientsDetail/ClientDetailModal';

const CustomModal = ({ modalState, closeModal, clientVehicles, clientServices }) => {
  const modalWidth = useBreakpointValue({ base: '90%', md: '80%' });

  return (
    <Modal isOpen={modalState.isOpen} onClose={closeModal} closeOnOverlayClick={false}>
      <ModalOverlay />
      <AdminModalContent maxW={modalWidth}>
        <ModalCloseButton />
        <ModalBody>
          {modalState.data?.actionType === 'view' && (
            <ClientDetailModal
              clientData={modalState.data.rowData}
              vehicles={clientVehicles}
              services={clientServices}
              onClose={closeModal}
            />
          )}
        </ModalBody>
      </AdminModalContent>
    </Modal>
  );
};

export default CustomModal;